export default "__VITE_ASSET__BhO9pzbK__"